export enum ApplicationActions {
  UPDATE_DISTRIBUTION_POINT,
  UPDATE_DISTRIBUTION_POINT_SUCCEDED,
  UPDATE_DISTRIBUTION_POINT_FAILED,
  UPDATE_DISTRIBUTION_POINT_IDLE,
}
